import { F } from '../styles/theme';
import { useTheme } from '../context/ThemeContext';
import { useT } from '../i18n/useT';
import { PRICING } from '../context/UserPlanContext';
import { OverlayHeader } from './red/OverlayHeader';

// Friendly Upgrade-Modal, wenn der User das TX-Jahres-Limit erreicht hat.
// Zwei Varianten:
//   - mode='block'    → User wollte 1 TX hinzufügen, ist aber bereits am Limit
//   - mode='exceed'   → CSV/Batch-Import würde Limit überschreiten
export default function LimitGateModal({
  open,
  mode = 'block',
  usage,           // { count, limit, year, wouldExceedBy?, newInYear? }
  currentTier = 'free',
  onClose,
  onUpgrade,       // (targetTier) => void  — öffnet Pricing-Screen
}) {
  const { T } = useTheme();
  const { t } = useT();
  if (!open || !usage) return null;

  const year = usage.year || new Date().getFullYear();
  const isFree = currentTier === 'free';
  const targetTier = isFree ? 'premium' : 'vip';
  const targetPrice = isFree ? PRICING.premium : PRICING.vip;
  const targetLimit = isFree ? '5.000' : t('mod_limit_unlimited');

  const title = mode === 'exceed'
    ? t('mod_limit_title_exceed')
    : t('mod_limit_title_block', { year });

  const subtitle = mode === 'exceed'
    ? t('mod_limit_sub_exceed', { n: usage.newInYear, fit: Math.max(0, usage.limit - usage.count), year })
    : t('mod_limit_sub_block', { limit: usage.limit, year, count: usage.count });

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 220,
        background: 'rgba(0,0,0,0.75)', display: 'flex',
        alignItems: 'flex-end', justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: 480,
          background: T.surface,
          backdropFilter: 'blur(32px) saturate(180%)',
          WebkitBackdropFilter: 'blur(32px) saturate(180%)',
          borderRadius: '24px 24px 0 0', padding: '28px 24px 36px',
          border: `1px solid ${T.line}`,
          maxHeight: '92vh', overflowY: 'auto',
        }}
      >
        <div style={{ width: 40, height: 4, background: T.dim, borderRadius: 2, margin: '0 auto 18px' }} />

        <div style={{ marginBottom: 20 }}>
          <OverlayHeader title={title} sub={subtitle} />
        </div>

        {/* Usage-Bar */}
        <div style={{
          background: T.glass,
          border: `1px solid ${T.glassBorder}`,
          borderRadius: 3, padding: '14px 16px', marginBottom: 18,
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, fontFamily: F.family, marginBottom: 8 }}>
            <span style={{ color: T.muted }}>{t('mod_limit_year_label', { year })}</span>
            <span style={{ color: T.text, fontWeight: 700 }}>{usage.count} / {usage.limit} TX</span>
          </div>
          <div style={{ height: 6, background: T.dim, borderRadius: 3, overflow: 'hidden' }}>
            <div style={{
              width: `${Math.min(100, (usage.count / usage.limit) * 100)}%`,
              height: '100%', background: T.red, borderRadius: 3,
            }} />
          </div>
        </div>

        {/* Upgrade-CTA */}
        <div style={{
          background: T.redGradient, color: T.white,
          borderRadius: 3, padding: '18px 20px', marginBottom: 12,
        }}>
          <div style={{ fontSize: 11, fontFamily: F.family, opacity: 0.85, letterSpacing: 0.5, marginBottom: 4 }}>
            {t('mod_limit_recommendation')}
          </div>
          <div style={{ fontSize: 18, fontWeight: 900, fontFamily: F.family, marginBottom: 4 }}>
            red. {targetPrice.label}
          </div>
          <div style={{ fontSize: 13, fontFamily: F.family, opacity: 0.9, marginBottom: 14, lineHeight: 1.5 }}>
            {t('mod_limit_features', { limit: targetLimit })}
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 12 }}>
            <span style={{ fontSize: 28, fontWeight: 900, fontFamily: F.family }}>€{targetPrice.price}</span>
            <span style={{ fontSize: 12, fontFamily: F.family, opacity: 0.85 }}>{targetPrice.unit}</span>
          </div>
          <button
            onClick={() => onUpgrade && onUpgrade(targetTier)}
            style={{
              width: '100%', padding: '14px',
              background: 'rgba(255,255,255,0.95)', color: T.red,
              border: 'none', borderRadius: 3,
              fontFamily: F.family, fontSize: 14, fontWeight: 800, cursor: 'pointer',
            }}
          >
            {t('mod_limit_view_plans')}
          </button>
        </div>

        <button
          onClick={onClose}
          style={{
            width: '100%', padding: '13px', background: 'none', color: T.muted,
            border: `1px solid ${T.line}`, borderRadius: 3,
            fontFamily: F.family, fontSize: 14, fontWeight: 600, cursor: 'pointer',
          }}
        >
          {t('mod_limit_later')}
        </button>

        <div style={{
          fontSize: 10, color: T.muted, fontFamily: F.family,
          textAlign: 'center', marginTop: 14, lineHeight: 1.5,
        }}>
          {t('mod_limit_reassure')}
        </div>
      </div>
    </div>
  );
}
